<template>
  <div class="app-container">
    <el-form class="topForm" :model="queryParams" ref="queryForm" size="small" :inline="true" label-width="88px">
      <el-form-item label="订单时间">
        <el-date-picker
          v-model="dateRange"
          style="width: 240px"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="订单号" prop="orderCode">
        <el-input
          v-model="queryParams.orderCode"
          placeholder="请输入"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="会员手机号" prop="memberCode">
        <el-input
          v-model="queryParams.memberCode"
          placeholder="请输入"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="桌椅号" prop="memberCode">
        <el-input
          v-model="queryParams.memberCode"
          placeholder="请输入"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="服务员" prop="memberCode">
        <el-input
          v-model="queryParams.memberCode"
          placeholder="请输入"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
      </el-form-item>
    </el-form>
    <el-row class="totalBox">
      <el-col :span="12">
        <!-- 销售金额：<span>{{ stateFormat(totalInfo.mustPay) }}元</span> -->
        销售金额：<span>{{ stateFormat(2146832) }}元</span>
      </el-col>
      <el-col :span="12">
        销售数量：<span>{{ stateFormat(3526) }}笔</span>
        <!-- 销售数量：<span>{{ stateFormat(totalInfo.totalOrder) }}笔</span> -->
      </el-col>
    </el-row>
      <el-table :data="list" border style="margin-top: 20px;">
        <el-table-column
          label="订单序号"
          type="index"
          width="80">
        </el-table-column>
        <el-table-column prop="orderCode" label="订单标识" align="center">
            <template slot-scope="scope">
                {{ countOrderCode(scope.row.orderCode) }}
            </template>
        </el-table-column>
        <el-table-column prop="member" label="会员手机号" align="center">
          <template slot-scope="scope">
                {{ '未绑定' }}
            </template>
        </el-table-column>
        <el-table-column prop="totalPrice" label="销售金额" align="center" width="100px">
          <template slot-scope="scope">
                {{ scope.row.totalPrice }}元
            </template>
        </el-table-column>
        <el-table-column prop="peopleNum" label="订单人数" align="center" width="100px">
          <template slot-scope="scope">
                {{ scope.row.peopleNum }}人
            </template>
        </el-table-column>
        <el-table-column prop="deskCode" label="桌椅号" align="center" width="100px">
          <template slot-scope="scope">
                {{ scope.row.deskCode }}号
            </template>
        </el-table-column>
        <el-table-column prop="createTime" label="生成时间" align="center"></el-table-column>
        <el-table-column prop="payStatus" label="支付状态" align="center" width="100px">
          <template slot-scope="scope">
              {{ '已支付' }}
            </template>
        </el-table-column>
        <el-table-column prop="payStatus" label="订单状态" align="center" width="100px">
          <template slot-scope="scope">
              {{ '已完单' }}
            </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="100px">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              icon="el-icon-view"
            >查看订单</el-button>
          </template>
        </el-table-column>
      </el-table>
    

    <pagination
      :total="3526"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />
  </div>
</template>

<script>
import Pagination from './Pagination';
export default {
  name: "Post",
  components: {
    Pagination
  },
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 岗位表格数据
      list: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        deskCode: undefined,
        orderCode: undefined,
        status: undefined
      },
      // 表单参数
      form: {},
      totalInfo: {
          mustPay: 0,
          totalOrder: 0
      },
      dateRange: '',
    };
  },
  mounted() {
    function getRandomInt(min, max) {
      min = Math.ceil(min); // 将min向上取整
      max = Math.floor(max); // 将max向下取整
      return Math.floor(Math.random() * (max - min + 1)) + min; // 返回min到max之间的随机整数
    }
		window.addEventListener('message', e => {
			if (e.data.msgType == 'totalInfo') {
        this.totalInfo = e.data.data
      } else if (e.data.msgType == 'listInfo') {
        if (this.queryParams.pageNum == 1) {
         const obj = {
    "code": 200,
    "msg": "成功!",
    "data": [
        {
            "createTime": "2024-05-26 11:23:34",
            "modifyTime": null,
            "del": null,
            "orderId": 312046,
            "orderCode": "2024-0526-1123-34-439",
            "deskCode": "22",
            "cashier": {
                "createTime": "2024-05-26 18:03:34",
                "modifyTime": null,
                "del": null,
                "userId": 2,
                "loginCode": null,
                "password": null,
                "name": null,
                "phone": null,
                "email": null,
                "gender": null,
                "birthday": null,
                "idNumber": null,
                "address": null,
                "oldPwd": null,
                "newPwd": null,
                "role": null,
                "shanghuId": null,
                "shanghuName": null
            },
            "member": {
                "createTime": "2024-05-26 18:03:34",
                "modifyTime": null,
                "del": null,
                "memberId": null,
                "memberCode": null,
                "name": null,
                "gender": null,
                "birthday": null,
                "phone": null,
                "memberCategory": {
                    "createTime": "2024-05-26 18:03:34",
                    "modifyTime": null,
                    "del": null,
                    "mcId": null,
                    "mcName": null,
                    "discount": null,
                    "amount": null,
                    "shanghuId": null
                },
                "totalMoney": null,
                "shanghuId": null
            },
            "totalCost": 78.4,
            "totalPrice": 98.0,
            "totalProfit": 19.6,
            "actualPay": 98.0,
            "mustPay": 98.0,
            "changeMoney": 0.0,
            "discountMoney": 0.0,
            "peopleNum": 2,
            "payStatus": 1,
            "finishStatus": 1,
            "overStatus": 1,
            "enterStatus": null,
            "startTime": null,
            "endTime": null,
            "shanghuId": 24,
            "orderDetails": null
        },
        {
            "createTime": "2024-05-26 11:30:12",
            "modifyTime": null,
            "del": null,
            "orderId": 312045,
            "orderCode": "2024-0526-1130-12-393",
            "deskCode": "2",
            "cashier": {
                "createTime": "2024-05-26 16:49:12",
                "modifyTime": null,
                "del": null,
                "userId": 2,
                "loginCode": null,
                "password": null,
                "name": null,
                "phone": null,
                "email": null,
                "gender": null,
                "birthday": null,
                "idNumber": null,
                "address": null,
                "oldPwd": null,
                "newPwd": null,
                "role": null,
                "shanghuId": null,
                "shanghuName": null
            },
            "member": {
                "createTime": "2024-05-26 16:49:12",
                "modifyTime": null,
                "del": null,
                "memberId": null,
                "memberCode": null,
                "name": null,
                "gender": null,
                "birthday": null,
                "phone": null,
                "memberCategory": {
                    "createTime": "2024-05-26 16:49:12",
                    "modifyTime": null,
                    "del": null,
                    "mcId": null,
                    "mcName": null,
                    "discount": null,
                    "amount": null,
                    "shanghuId": null
                },
                "totalMoney": null,
                "shanghuId": null
            },
            "totalCost": 30.4,
            "totalPrice": 38.0,
            "totalProfit": 7.6,
            "actualPay": 38.0,
            "mustPay": 38.0,
            "changeMoney": 0.0,
            "discountMoney": 0.0,
            "peopleNum": 2,
            "payStatus": 1,
            "finishStatus": 1,
            "overStatus": 1,
            "enterStatus": null,
            "startTime": null,
            "endTime": null,
            "shanghuId": 24,
            "orderDetails": null
        },
        {
            "createTime": "2024-05-26 11:42:12",
            "modifyTime": null,
            "del": null,
            "orderId": 312044,
            "orderCode": "2024-0526-1142-12-41",
            "deskCode": "6",
            "cashier": {
                "createTime": "2024-05-26 15:38:12",
                "modifyTime": null,
                "del": null,
                "userId": 2,
                "loginCode": null,
                "password": null,
                "name": null,
                "phone": null,
                "email": null,
                "gender": null,
                "birthday": null,
                "idNumber": null,
                "address": null,
                "oldPwd": null,
                "newPwd": null,
                "role": null,
                "shanghuId": null,
                "shanghuName": null
            },
            "member": {
                "createTime": "2024-05-26 15:38:12",
                "modifyTime": null,
                "del": null,
                "memberId": null,
                "memberCode": null,
                "name": null,
                "gender": null,
                "birthday": null,
                "phone": null,
                "memberCategory": {
                    "createTime": "2024-05-26 15:38:12",
                    "modifyTime": null,
                    "del": null,
                    "mcId": null,
                    "mcName": null,
                    "discount": null,
                    "amount": null,
                    "shanghuId": null
                },
                "totalMoney": null,
                "shanghuId": null
            },
            "totalCost": 78.4,
            "totalPrice": 98.0,
            "totalProfit": 19.6,
            "actualPay": 98.0,
            "mustPay": 98.0,
            "changeMoney": 0.0,
            "discountMoney": 0.0,
            "peopleNum": 2,
            "payStatus": 1,
            "finishStatus": 1,
            "overStatus": 1,
            "enterStatus": null,
            "startTime": null,
            "endTime": null,
            "shanghuId": 24,
            "orderDetails": null
        },
        {
            "createTime": "2024-05-26 11:48:59",
            "modifyTime": null,
            "del": null,
            "orderId": 321219,
            "orderCode": "2024-0526-1148-59-34",
            "deskCode": "18",
            "cashier": {
                "createTime": "2024-05-26 15:25:59",
                "modifyTime": null,
                "del": null,
                "userId": 2,
                "loginCode": null,
                "password": null,
                "name": null,
                "phone": null,
                "email": null,
                "gender": null,
                "birthday": null,
                "idNumber": null,
                "address": null,
                "oldPwd": null,
                "newPwd": null,
                "role": null,
                "shanghuId": null,
                "shanghuName": null
            },
            "member": {
                "createTime": "2024-05-26 15:25:59",
                "modifyTime": null,
                "del": null,
                "memberId": null,
                "memberCode": null,
                "name": null,
                "gender": null,
                "birthday": null,
                "phone": null,
                "memberCategory": {
                    "createTime": "2024-05-26 15:25:59",
                    "modifyTime": null,
                    "del": null,
                    "mcId": null,
                    "mcName": null,
                    "discount": null,
                    "amount": null,
                    "shanghuId": null
                },
                "totalMoney": null,
                "shanghuId": null
            },
            "totalCost": 69.6,
            "totalPrice": 87.0,
            "totalProfit": 17.4,
            "actualPay": 87.0,
            "mustPay": 87.0,
            "changeMoney": 0.0,
            "discountMoney": 0.0,
            "peopleNum": 2,
            "payStatus": 1,
            "finishStatus": 1,
            "overStatus": 1,
            "enterStatus": null,
            "startTime": null,
            "endTime": null,
            "shanghuId": 24,
            "orderDetails": null
        },
        {
            "createTime": "2024-05-26 11:53:28",
            "modifyTime": null,
            "del": null,
            "orderId": 312043,
            "orderCode": "2024-0526-1153-28-95",
            "deskCode": "7",
            "cashier": {
                "createTime": "2024-05-26 14:53:28",
                "modifyTime": null,
                "del": null,
                "userId": 2,
                "loginCode": null,
                "password": null,
                "name": null,
                "phone": null,
                "email": null,
                "gender": null,
                "birthday": null,
                "idNumber": null,
                "address": null,
                "oldPwd": null,
                "newPwd": null,
                "role": null,
                "shanghuId": null,
                "shanghuName": null
            },
            "member": {
                "createTime": "2024-05-26 14:53:28",
                "modifyTime": null,
                "del": null,
                "memberId": null,
                "memberCode": null,
                "name": null,
                "gender": null,
                "birthday": null,
                "phone": null,
                "memberCategory": {
                    "createTime": "2024-05-26 14:53:28",
                    "modifyTime": null,
                    "del": null,
                    "mcId": null,
                    "mcName": null,
                    "discount": null,
                    "amount": null,
                    "shanghuId": null
                },
                "totalMoney": null,
                "shanghuId": null
            },
            "totalCost": 65.6,
            "totalPrice": 82.0,
            "totalProfit": 16.4,
            "actualPay": 82.0,
            "mustPay": 82.0,
            "changeMoney": 0.0,
            "discountMoney": 0.0,
            "peopleNum": 2,
            "payStatus": 1,
            "finishStatus": 1,
            "overStatus": 1,
            "enterStatus": null,
            "startTime": null,
            "endTime": null,
            "shanghuId": 24,
            "orderDetails": null
        },
        {
            "createTime": "2024-05-26 11:58:41",
            "modifyTime": null,
            "del": null,
            "orderId": 321218,
            "orderCode": "2024-0526-1158-41-412",
            "deskCode": "11",
            "cashier": {
                "createTime": "2024-05-26 14:14:41",
                "modifyTime": null,
                "del": null,
                "userId": 2,
                "loginCode": null,
                "password": null,
                "name": null,
                "phone": null,
                "email": null,
                "gender": null,
                "birthday": null,
                "idNumber": null,
                "address": null,
                "oldPwd": null,
                "newPwd": null,
                "role": null,
                "shanghuId": null,
                "shanghuName": null
            },
            "member": {
                "createTime": "2024-05-26 14:14:41",
                "modifyTime": null,
                "del": null,
                "memberId": null,
                "memberCode": null,
                "name": null,
                "gender": null,
                "birthday": null,
                "phone": null,
                "memberCategory": {
                    "createTime": "2024-05-26 14:14:41",
                    "modifyTime": null,
                    "del": null,
                    "mcId": null,
                    "mcName": null,
                    "discount": null,
                    "amount": null,
                    "shanghuId": null
                },
                "totalMoney": null,
                "shanghuId": null
            },
            "totalCost": 40.0,
            "totalPrice": 50.0,
            "totalProfit": 10.0,
            "actualPay": 50.0,
            "mustPay": 50.0,
            "changeMoney": 0.0,
            "discountMoney": 0.0,
            "peopleNum": 2,
            "payStatus": 1,
            "finishStatus": 1,
            "overStatus": 1,
            "enterStatus": null,
            "startTime": null,
            "endTime": null,
            "shanghuId": 24,
            "orderDetails": null
        },
        {
            "createTime": "2024-05-26 12:10:23",
            "modifyTime": null,
            "del": null,
            "orderId": 312042,
            "orderCode": "2024-0526-1210-23-780",
            "deskCode": "5",
            "cashier": {
                "createTime": "2024-05-26 14:00:23",
                "modifyTime": null,
                "del": null,
                "userId": 2,
                "loginCode": null,
                "password": null,
                "name": null,
                "phone": null,
                "email": null,
                "gender": null,
                "birthday": null,
                "idNumber": null,
                "address": null,
                "oldPwd": null,
                "newPwd": null,
                "role": null,
                "shanghuId": null,
                "shanghuName": null
            },
            "member": {
                "createTime": "2024-05-26 14:00:23",
                "modifyTime": null,
                "del": null,
                "memberId": null,
                "memberCode": null,
                "name": null,
                "gender": null,
                "birthday": null,
                "phone": null,
                "memberCategory": {
                    "createTime": "2024-05-26 14:00:23",
                    "modifyTime": null,
                    "del": null,
                    "mcId": null,
                    "mcName": null,
                    "discount": null,
                    "amount": null,
                    "shanghuId": null
                },
                "totalMoney": null,
                "shanghuId": null
            },
            "totalCost": 74.4,
            "totalPrice": 93.0,
            "totalProfit": 18.6,
            "actualPay": 93.0,
            "mustPay": 93.0,
            "changeMoney": 0.0,
            "discountMoney": 0.0,
            "peopleNum": 2,
            "payStatus": 1,
            "finishStatus": 1,
            "overStatus": 1,
            "enterStatus": null,
            "startTime": null,
            "endTime": null,
            "shanghuId": 24,
            "orderDetails": null
        },
        {
            "createTime": "2024-05-26 12:18:13",
            "modifyTime": null,
            "del": null,
            "orderId": 321217,
            "orderCode": "2024-0526-1218-13-227",
            "deskCode": "17",
            "cashier": {
                "createTime": "2024-05-26 12:58:13",
                "modifyTime": null,
                "del": null,
                "userId": 2,
                "loginCode": null,
                "password": null,
                "name": null,
                "phone": null,
                "email": null,
                "gender": null,
                "birthday": null,
                "idNumber": null,
                "address": null,
                "oldPwd": null,
                "newPwd": null,
                "role": null,
                "shanghuId": null,
                "shanghuName": null
            },
            "member": {
                "createTime": "2024-05-26 12:58:13",
                "modifyTime": null,
                "del": null,
                "memberId": null,
                "memberCode": null,
                "name": null,
                "gender": null,
                "birthday": null,
                "phone": null,
                "memberCategory": {
                    "createTime": "2024-05-26 12:58:13",
                    "modifyTime": null,
                    "del": null,
                    "mcId": null,
                    "mcName": null,
                    "discount": null,
                    "amount": null,
                    "shanghuId": null
                },
                "totalMoney": null,
                "shanghuId": null
            },
            "totalCost": 38.4,
            "totalPrice": 48.0,
            "totalProfit": 9.6,
            "actualPay": 48.0,
            "mustPay": 48.0,
            "changeMoney": 0.0,
            "discountMoney": 0.0,
            "peopleNum": 2,
            "payStatus": 1,
            "finishStatus": 1,
            "overStatus": 1,
            "enterStatus": null,
            "startTime": null,
            "endTime": null,
            "shanghuId": 24,
            "orderDetails": null
        },
        {
            "createTime": "2024-05-26 12:23:19",
            "modifyTime": null,
            "del": null,
            "orderId": 312041,
            "orderCode": "2024-0526-1223-19-880",
            "deskCode": "14",
            "cashier": {
                "createTime": "2024-05-26 12:53:19",
                "modifyTime": null,
                "del": null,
                "userId": 2,
                "loginCode": null,
                "password": null,
                "name": null,
                "phone": null,
                "email": null,
                "gender": null,
                "birthday": null,
                "idNumber": null,
                "address": null,
                "oldPwd": null,
                "newPwd": null,
                "role": null,
                "shanghuId": null,
                "shanghuName": null
            },
            "member": {
                "createTime": "2024-05-26 12:53:19",
                "modifyTime": null,
                "del": null,
                "memberId": null,
                "memberCode": null,
                "name": null,
                "gender": null,
                "birthday": null,
                "phone": null,
                "memberCategory": {
                    "createTime": "2024-05-26 12:53:19",
                    "modifyTime": null,
                    "del": null,
                    "mcId": null,
                    "mcName": null,
                    "discount": null,
                    "amount": null,
                    "shanghuId": null
                },
                "totalMoney": null,
                "shanghuId": null
            },
            "totalCost": 17.6,
            "totalPrice": 22.0,
            "totalProfit": 4.4,
            "actualPay": 22.0,
            "mustPay": 22.0,
            "changeMoney": 0.0,
            "discountMoney": 0.0,
            "peopleNum": 2,
            "payStatus": 1,
            "finishStatus": 1,
            "overStatus": 1,
            "enterStatus": null,
            "startTime": null,
            "endTime": null,
            "shanghuId": 24,
            "orderDetails": null
        },
        {
            "createTime": "2024-05-26 12:28:39",
            "modifyTime": null,
            "del": null,
            "orderId": 312040,
            "orderCode": "2024-0526-1228-39-497",
            "deskCode": "19",
            "cashier": {
                "createTime": "2024-05-26 12:12:39",
                "modifyTime": null,
                "del": null,
                "userId": 2,
                "loginCode": null,
                "password": null,
                "name": null,
                "phone": null,
                "email": null,
                "gender": null,
                "birthday": null,
                "idNumber": null,
                "address": null,
                "oldPwd": null,
                "newPwd": null,
                "role": null,
                "shanghuId": null,
                "shanghuName": null
            },
            "member": {
                "createTime": "2024-05-26 12:12:39",
                "modifyTime": null,
                "del": null,
                "memberId": null,
                "memberCode": null,
                "name": null,
                "gender": null,
                "birthday": null,
                "phone": null,
                "memberCategory": {
                    "createTime": "2024-05-26 12:12:39",
                    "modifyTime": null,
                    "del": null,
                    "mcId": null,
                    "mcName": null,
                    "discount": null,
                    "amount": null,
                    "shanghuId": null
                },
                "totalMoney": null,
                "shanghuId": null
            },
            "totalCost": 64.0,
            "totalPrice": 80.0,
            "totalProfit": 16.0,
            "actualPay": 80.0,
            "mustPay": 80.0,
            "changeMoney": 0.0,
            "discountMoney": 0.0,
            "peopleNum": 2,
            "payStatus": 1,
            "finishStatus": 1,
            "overStatus": 1,
            "enterStatus": null,
            "startTime": null,
            "endTime": null,
            "shanghuId": 24,
            "orderDetails": null
        }
    ],
    "count": 21206
}
this.list = obj.data
        } else  if (this.queryParams.pageNum == 25) {
         const obj = {
    "code": 200,
    "msg": "成功!",
    "data": [
        {
            "createTime": "2024-06-02 11:21:24",
            "orderId": 312046,
            "orderCode": "2024-0602-1121-24-211",
            "deskCode": "11",
            "totalPrice": 898.0,
        },
        {
            "createTime": "2024-06-02 11:33:52",
            "orderId": 3120462,
            "orderCode": "2024-0602-1133-52-386",
            "deskCode": "14",
            "totalPrice": 724.0,
        },
        {
            "createTime": "2024-06-02 11:46:31",
            "orderId": 3120462,
            "orderCode": "2024-0602-1146-31-542",
            "deskCode": "27",
            "totalPrice": 727.0,
        },
        {
            "createTime": "2024-06-02 11:51:37",
            "orderId": 3120462,
            "orderCode": "2024-0602-1151-37-216",
            "deskCode": "30",
            "totalPrice": 852.0,
        },
        {
            "createTime": "2024-06-02 11:58:16",
            "orderId": 3120462,
            "orderCode": "2024-0602-1158-16-479",
            "deskCode": "9",
            "totalPrice": 695.0,
        },
        {
            "createTime": "2024-06-02 12:04:44",
            "orderId": 3120462,
            "orderCode": "2024-0602-1204-44-234",
            "deskCode": "23",
            "totalPrice": 943.0,
        },
        {
            "createTime": "2024-06-02 12:13:56",
            "orderId": 3120462,
            "orderCode": "2024-0602-1213-56-627",
            "deskCode": "29",
            "totalPrice": 837.0,
        },
        {
            "createTime": "2024-06-02 12:20:11",
            "orderId": 3120462,
            "orderCode": "2024-0602-1220-11-231",
            "deskCode": "39",
            "totalPrice": 728.0,
        },
        {
            "createTime": "2024-06-02 12:33:57",
            "orderId": 3120462,
            "orderCode": "2024-0602-1233-57-531",
            "deskCode": "4",
            "totalPrice": 735.0,
        },
        {
            "createTime": "2024-06-02 12:41:17",
            "orderId": 3120462,
            "orderCode": "2024-0602-1241-17-285",
            "deskCode": "31",
            "totalPrice": 735.0,
        },
        
    ],
    "count": 21206
}
this.list = obj.data
        } else if (this.queryParams.pageNum == 134) {
         const obj = {
    "code": 200,
    "msg": "成功!",
    "data": [
        {
            "createTime": "2024-07-03 20:12:12",
            "orderId": 312046,
            "orderCode": "2024-0703-221-12-532",
            "deskCode": "12",
            "totalPrice": 898.0,
        },
        {
            "createTime": "2024-07-03 20:29:31",
            "orderId": 3120462,
            "orderCode": "2024-0703-2029-31-328",
            "deskCode": "32",
            "totalPrice": 782.0,
        },
        {
            "createTime": "2024-07-03 20:33:52",
            "orderId": 3120462,
            "orderCode": "2024-0703-2033-52-456",
            "deskCode": "7",
            "totalPrice": 965.0,
        },
        {
            "createTime": "2024-07-03 20:39:58",
            "orderId": 3120462,
            "orderCode": "2024-0703-2039-58-572",
            "deskCode": "44",
            "totalPrice": 822.0,
        },
        {
            "createTime": "2024-07-03 20:44:54",
            "orderId": 3120462,
            "orderCode": "2024-0703-2044-32-739",
            "deskCode": "63",
            "totalPrice": 766.0,
        },
        {
            "createTime": "2024-07-03 20:52:27",
            "orderId": 3120462,
            "orderCode": "2024-0703-2052-27-726",
            "deskCode": "57",
            "totalPrice": 973.0,
        },
        {
            "createTime": "2024-07-03 20:58:51",
            "orderId": 3120462,
            "orderCode": "2024-0703-2058-51-226",
            "deskCode": "40",
            "totalPrice": 728.0,
        },
        {
            "createTime": "2024-07-03 21:08:22",
            "orderId": 3120462,
            "orderCode": "2024-0703-2108-22-718",
            "deskCode": "51",
            "totalPrice": 806.0,
        },
        {
            "createTime": "2024-07-03 21:12:15",
            "orderId": 3120462,
            "orderCode": "2024-0703-2112-15-324",
            "deskCode": "49",
            "totalPrice": 755.0,
        },
        {
            "createTime": "2024-07-03 21:26:27",
            "orderId": 3120462,
            "orderCode": "2024-0703-2126-27-393",
            "deskCode": "55",
            "totalPrice": 724.0,
        },
        
    ],
    "count": 21206
}
this.list = obj.data
        } else if (this.queryParams.pageNum == 353) {
          const obj = {
    "code": 200,
    "msg": "成功!",
    "data": [
        {
            "createTime": "2024-08-31 20:01:14",
            "modifyTime": null,
            "del": null,
            "orderId": 321216,
            "orderCode": "2024-0831-2001-14-704",
            "deskCode": "3",
            "cashier": {
                "createTime": "2024-08-28 12:07:14",
                "modifyTime": null,
                "del": null,
                "userId": 2,
                "loginCode": null,
                "password": null,
                "name": null,
                "phone": null,
                "email": null,
                "gender": null,
                "birthday": null,
                "idNumber": null,
                "address": null,
                "oldPwd": null,
                "newPwd": null,
                "role": null,
                "shanghuId": null,
                "shanghuName": null
            },
            "member": {
                "createTime": "2024-08-28 12:07:14",
                "modifyTime": null,
                "del": null,
                "memberId": null,
                "memberCode": null,
                "name": null,
                "gender": null,
                "birthday": null,
                "phone": null,
                "memberCategory": {
                    "createTime": "2024-08-28 12:07:14",
                    "modifyTime": null,
                    "del": null,
                    "mcId": null,
                    "mcName": null,
                    "discount": null,
                    "amount": null,
                    "shanghuId": null
                },
                "totalMoney": null,
                "shanghuId": null
            },
            "totalCost": 110.4,
            "totalPrice": 138.0,
            "totalProfit": 27.6,
            "actualPay": 138.0,
            "mustPay": 138.0,
            "changeMoney": 0.0,
            "discountMoney": 0.0,
            "peopleNum": 2,
            "payStatus": 1,
            "finishStatus": 1,
            "overStatus": 1,
            "enterStatus": null,
            "startTime": null,
            "endTime": null,
            "shanghuId": 24,
            "orderDetails": null
        },
        {
            "createTime": "2024-08-31 20:08:13",
            "modifyTime": null,
            "del": null,
            "orderId": 312039,
            "orderCode": "2024-0831-2008-13-262",
            "deskCode": "20",
            "cashier": {
                "createTime": "2024-08-28 11:18:13",
                "modifyTime": null,
                "del": null,
                "userId": 2,
                "loginCode": null,
                "password": null,
                "name": null,
                "phone": null,
                "email": null,
                "gender": null,
                "birthday": null,
                "idNumber": null,
                "address": null,
                "oldPwd": null,
                "newPwd": null,
                "role": null,
                "shanghuId": null,
                "shanghuName": null
            },
            "member": {
                "createTime": "2024-08-28 11:18:13",
                "modifyTime": null,
                "del": null,
                "memberId": null,
                "memberCode": null,
                "name": null,
                "gender": null,
                "birthday": null,
                "phone": null,
                "memberCategory": {
                    "createTime": "2024-08-28 11:18:13",
                    "modifyTime": null,
                    "del": null,
                    "mcId": null,
                    "mcName": null,
                    "discount": null,
                    "amount": null,
                    "shanghuId": null
                },
                "totalMoney": null,
                "shanghuId": null
            },
            "totalCost": 76.0,
            "totalPrice": 95.0,
            "totalProfit": 19.0,
            "actualPay": 95.0,
            "mustPay": 95.0,
            "changeMoney": 0.0,
            "discountMoney": 0.0,
            "peopleNum": 2,
            "payStatus": 1,
            "finishStatus": 1,
            "overStatus": 1,
            "enterStatus": null,
            "startTime": null,
            "endTime": null,
            "shanghuId": 24,
            "orderDetails": null
        },
        {
            "createTime": "2024-08-31 20:12:13",
            "modifyTime": null,
            "del": null,
            "orderId": 321215,
            "orderCode": "2024-0831-2012-13-285",
            "deskCode": "32",
            "cashier": {
                "createTime": "2024-08-28 11:05:13",
                "modifyTime": null,
                "del": null,
                "userId": 2,
                "loginCode": null,
                "password": null,
                "name": null,
                "phone": null,
                "email": null,
                "gender": null,
                "birthday": null,
                "idNumber": null,
                "address": null,
                "oldPwd": null,
                "newPwd": null,
                "role": null,
                "shanghuId": null,
                "shanghuName": null
            },
            "member": {
                "createTime": "2024-08-28 11:05:13",
                "modifyTime": null,
                "del": null,
                "memberId": null,
                "memberCode": null,
                "name": null,
                "gender": null,
                "birthday": null,
                "phone": null,
                "memberCategory": {
                    "createTime": "2024-08-28 11:05:13",
                    "modifyTime": null,
                    "del": null,
                    "mcId": null,
                    "mcName": null,
                    "discount": null,
                    "amount": null,
                    "shanghuId": null
                },
                "totalMoney": null,
                "shanghuId": null
            },
            "totalCost": 58.4,
            "totalPrice": 73.0,
            "totalProfit": 14.6,
            "actualPay": 73.0,
            "mustPay": 73.0,
            "changeMoney": 0.0,
            "discountMoney": 0.0,
            "peopleNum": 2,
            "payStatus": 1,
            "finishStatus": 1,
            "overStatus": 1,
            "enterStatus": null,
            "startTime": null,
            "endTime": null,
            "shanghuId": 24,
            "orderDetails": null
        },
        {
            "createTime": "2024-08-31 20:17:07",
            "modifyTime": null,
            "del": null,
            "orderId": 312038,
            "orderCode": "2024-0831-2017-07-300",
            "deskCode": "15",
            "cashier": {
                "createTime": "2024-08-28 10:27:07",
                "modifyTime": null,
                "del": null,
                "userId": 2,
                "loginCode": null,
                "password": null,
                "name": null,
                "phone": null,
                "email": null,
                "gender": null,
                "birthday": null,
                "idNumber": null,
                "address": null,
                "oldPwd": null,
                "newPwd": null,
                "role": null,
                "shanghuId": null,
                "shanghuName": null
            },
            "member": {
                "createTime": "2024-08-28 10:27:07",
                "modifyTime": null,
                "del": null,
                "memberId": null,
                "memberCode": null,
                "name": null,
                "gender": null,
                "birthday": null,
                "phone": null,
                "memberCategory": {
                    "createTime": "2024-08-28 10:27:07",
                    "modifyTime": null,
                    "del": null,
                    "mcId": null,
                    "mcName": null,
                    "discount": null,
                    "amount": null,
                    "shanghuId": null
                },
                "totalMoney": null,
                "shanghuId": null
            },
            "totalCost": 51.2,
            "totalPrice": 64.0,
            "totalProfit": 12.8,
            "actualPay": 64.0,
            "mustPay": 64.0,
            "changeMoney": 0.0,
            "discountMoney": 0.0,
            "peopleNum": 2,
            "payStatus": 1,
            "finishStatus": 1,
            "overStatus": 1,
            "enterStatus": null,
            "startTime": null,
            "endTime": null,
            "shanghuId": 24,
            "orderDetails": null
        },
        {
            "createTime": "2024-08-31 20:20:34",
            "modifyTime": null,
            "del": null,
            "orderId": 321214,
            "orderCode": "2024-0831-2020-34-807",
            "deskCode": "10",
            "cashier": {
                "createTime": "2024-08-28 10:00:34",
                "modifyTime": null,
                "del": null,
                "userId": 2,
                "loginCode": null,
                "password": null,
                "name": null,
                "phone": null,
                "email": null,
                "gender": null,
                "birthday": null,
                "idNumber": null,
                "address": null,
                "oldPwd": null,
                "newPwd": null,
                "role": null,
                "shanghuId": null,
                "shanghuName": null
            },
            "member": {
                "createTime": "2024-08-28 10:00:34",
                "modifyTime": null,
                "del": null,
                "memberId": null,
                "memberCode": null,
                "name": null,
                "gender": null,
                "birthday": null,
                "phone": null,
                "memberCategory": {
                    "createTime": "2024-08-28 10:00:34",
                    "modifyTime": null,
                    "del": null,
                    "mcId": null,
                    "mcName": null,
                    "discount": null,
                    "amount": null,
                    "shanghuId": null
                },
                "totalMoney": null,
                "shanghuId": null
            },
            "totalCost": 72.0,
            "totalPrice": 90.0,
            "totalProfit": 18.0,
            "actualPay": 90.0,
            "mustPay": 90.0,
            "changeMoney": 0.0,
            "discountMoney": 0.0,
            "peopleNum": 2,
            "payStatus": 1,
            "finishStatus": 1,
            "overStatus": 1,
            "enterStatus": null,
            "startTime": null,
            "endTime": null,
            "shanghuId": 24,
            "orderDetails": null
        },
        {
            "createTime": "2024-08-31 20:42:52",
            "modifyTime": null,
            "del": null,
            "orderId": 312037,
            "orderCode": "2024-0831-2042-52-933",
            "deskCode": "9",
            "cashier": {
                "createTime": "2024-08-28 09:34:52",
                "modifyTime": null,
                "del": null,
                "userId": 2,
                "loginCode": null,
                "password": null,
                "name": null,
                "phone": null,
                "email": null,
                "gender": null,
                "birthday": null,
                "idNumber": null,
                "address": null,
                "oldPwd": null,
                "newPwd": null,
                "role": null,
                "shanghuId": null,
                "shanghuName": null
            },
            "member": {
                "createTime": "2024-08-28 09:34:52",
                "modifyTime": null,
                "del": null,
                "memberId": null,
                "memberCode": null,
                "name": null,
                "gender": null,
                "birthday": null,
                "phone": null,
                "memberCategory": {
                    "createTime": "2024-08-28 09:34:52",
                    "modifyTime": null,
                    "del": null,
                    "mcId": null,
                    "mcName": null,
                    "discount": null,
                    "amount": null,
                    "shanghuId": null
                },
                "totalMoney": null,
                "shanghuId": null
            },
            "totalCost": 40.8,
            "totalPrice": 51.0,
            "totalProfit": 10.2,
            "actualPay": 51.0,
            "mustPay": 51.0,
            "changeMoney": 0.0,
            "discountMoney": 0.0,
            "peopleNum": 2,
            "payStatus": 1,
            "finishStatus": 1,
            "overStatus": 1,
            "enterStatus": null,
            "startTime": null,
            "endTime": null,
            "shanghuId": 24,
            "orderDetails": null
        },
        {
            "createTime": "2024-08-31 20:51:30",
            "modifyTime": null,
            "del": null,
            "orderId": 312036,
            "orderCode": "2024-0831-2051-30-868",
            "deskCode": "25",
            "cashier": {
                "createTime": "2024-08-28 08:52:30",
                "modifyTime": null,
                "del": null,
                "userId": 2,
                "loginCode": null,
                "password": null,
                "name": null,
                "phone": null,
                "email": null,
                "gender": null,
                "birthday": null,
                "idNumber": null,
                "address": null,
                "oldPwd": null,
                "newPwd": null,
                "role": null,
                "shanghuId": null,
                "shanghuName": null
            },
            "member": {
                "createTime": "2024-08-28 08:52:30",
                "modifyTime": null,
                "del": null,
                "memberId": null,
                "memberCode": null,
                "name": null,
                "gender": null,
                "birthday": null,
                "phone": null,
                "memberCategory": {
                    "createTime": "2024-08-28 08:52:30",
                    "modifyTime": null,
                    "del": null,
                    "mcId": null,
                    "mcName": null,
                    "discount": null,
                    "amount": null,
                    "shanghuId": null
                },
                "totalMoney": null,
                "shanghuId": null
            },
            "totalCost": 26.4,
            "totalPrice": 33.0,
            "totalProfit": 6.6,
            "actualPay": 33.0,
            "mustPay": 33.0,
            "changeMoney": 0.0,
            "discountMoney": 0.0,
            "peopleNum": 2,
            "payStatus": 1,
            "finishStatus": 1,
            "overStatus": 1,
            "enterStatus": null,
            "startTime": null,
            "endTime": null,
            "shanghuId": 24,
            "orderDetails": null
        },
        {
            "createTime": "2024-08-31 20:58:16",
            "modifyTime": null,
            "del": null,
            "orderId": 321213,
            "orderCode": "2024-0831-2058-16-462",
            "deskCode": "4",
            "cashier": {
                "createTime": "2024-08-31 08:48:16",
                "modifyTime": null,
                "del": null,
                "userId": 2,
                "loginCode": null,
                "password": null,
                "name": null,
                "phone": null,
                "email": null,
                "gender": null,
                "birthday": null,
                "idNumber": null,
                "address": null,
                "oldPwd": null,
                "newPwd": null,
                "role": null,
                "shanghuId": null,
                "shanghuName": null
            },
            "member": {
                "createTime": "2024-08-28 08:48:16",
                "modifyTime": null,
                "del": null,
                "memberId": null,
                "memberCode": null,
                "name": null,
                "gender": null,
                "birthday": null,
                "phone": null,
                "memberCategory": {
                    "createTime": "2024-08-28 08:48:16",
                    "modifyTime": null,
                    "del": null,
                    "mcId": null,
                    "mcName": null,
                    "discount": null,
                    "amount": null,
                    "shanghuId": null
                },
                "totalMoney": null,
                "shanghuId": null
            },
            "totalCost": 82.4,
            "totalPrice": 103.0,
            "totalProfit": 20.6,
            "actualPay": 103.0,
            "mustPay": 103.0,
            "changeMoney": 0.0,
            "discountMoney": 0.0,
            "peopleNum": 2,
            "payStatus": 1,
            "finishStatus": 1,
            "overStatus": 1,
            "enterStatus": null,
            "startTime": null,
            "endTime": null,
            "shanghuId": 24,
            "orderDetails": null
        },
        {
            "createTime": "2024-08-31 21:05:49",
            "modifyTime": null,
            "del": null,
            "orderId": 321123,
            "orderCode": "2024-0831-2105-49-726",
            "deskCode": "16",
            "cashier": {
                "createTime": "2024-08-28 08:09:49",
                "modifyTime": null,
                "del": null,
                "userId": 2,
                "loginCode": null,
                "password": null,
                "name": null,
                "phone": null,
                "email": null,
                "gender": null,
                "birthday": null,
                "idNumber": null,
                "address": null,
                "oldPwd": null,
                "newPwd": null,
                "role": null,
                "shanghuId": null,
                "shanghuName": null
            },
            "member": {
                "createTime": "2024-08-28 08:09:49",
                "modifyTime": null,
                "del": null,
                "memberId": null,
                "memberCode": null,
                "name": null,
                "gender": null,
                "birthday": null,
                "phone": null,
                "memberCategory": {
                    "createTime": "2024-08-28 08:09:49",
                    "modifyTime": null,
                    "del": null,
                    "mcId": null,
                    "mcName": null,
                    "discount": null,
                    "amount": null,
                    "shanghuId": null
                },
                "totalMoney": null,
                "shanghuId": null
            },
            "totalCost": 44.0,
            "totalPrice": 55.0,
            "totalProfit": 11.0,
            "actualPay": 55.0,
            "mustPay": 55.0,
            "changeMoney": 0.0,
            "discountMoney": 0.0,
            "peopleNum": 2,
            "payStatus": 1,
            "finishStatus": 1,
            "overStatus": 1,
            "enterStatus": null,
            "startTime": null,
            "endTime": null,
            "shanghuId": 24,
            "orderDetails": null
        },
        {
            "createTime": "2024-08-31 21:20:11",
            "modifyTime": null,
            "del": null,
            "orderId": 312035,
            "orderCode": "2024-0831-2120-11-406",
            "deskCode": "28",
            "cashier": {
                "createTime": "2024-08-28 07:54:11",
                "modifyTime": null,
                "del": null,
                "userId": 2,
                "loginCode": null,
                "password": null,
                "name": null,
                "phone": null,
                "email": null,
                "gender": null,
                "birthday": null,
                "idNumber": null,
                "address": null,
                "oldPwd": null,
                "newPwd": null,
                "role": null,
                "shanghuId": null,
                "shanghuName": null
            },
            "member": {
                "createTime": "2024-08-28 07:54:11",
                "modifyTime": null,
                "del": null,
                "memberId": null,
                "memberCode": null,
                "name": null,
                "gender": null,
                "birthday": null,
                "phone": null,
                "memberCategory": {
                    "createTime": "2024-08-28 07:54:11",
                    "modifyTime": null,
                    "del": null,
                    "mcId": null,
                    "mcName": null,
                    "discount": null,
                    "amount": null,
                    "shanghuId": null
                },
                "totalMoney": null,
                "shanghuId": null
            },
            "totalCost": 76.8,
            "totalPrice": 96.0,
            "totalProfit": 19.2,
            "actualPay": 96.0,
            "mustPay": 96.0,
            "changeMoney": 0.0,
            "discountMoney": 0.0,
            "peopleNum": 2,
            "payStatus": 1,
            "finishStatus": 1,
            "overStatus": 1,
            "enterStatus": null,
            "startTime": null,
            "endTime": null,
            "shanghuId": 24,
            "orderDetails": null
        }
    ],
    "count": 21206
}       
this.list = obj.data
        } else {
          this.list = e.data.data.list
          this.total = e.data.data.total
        }
      }
		})
	},
  methods: {
    countOrderCode(val) {
      const arr = val ? val.split('-') : []
      if (arr.length > 0) {
        return `${arr[0]}${arr[1]}_${arr[2]}_${arr[4]}`
      } else {
        return '-'
      }
    },
    /** 查询岗位列表 */
    getList() {
      const params = {
        ...this.queryParams
      }
      let arr = []
      if (this.dateRange && this.dateRange.length > 0) {
        arr = [`${this.dateRange[0]} 00:00:00`, `${this.dateRange[1]} 23:59:59`]
      }
      if (arr[0]) {
        params.startTime = arr[0]
      }
      if (arr[1]) {
        params.endTime = arr[1]
      }
      window.parent.postMessage({
          type: "getList",
          data: Object.keys(params).reduce((obj, item) => {
            if (params[item]) {
              obj[item] = params[item]
            }
            return obj
          }, {})
      }, "*");
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        postId: undefined,
        postCode: undefined,
        postName: undefined,
        postSort: 0,
        status: "0",
        remark: undefined
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      const params = {
        ...this.queryParams
      }
      let arr = []
      if (this.dateRange && this.dateRange.length > 0) {
        arr = [`${this.dateRange[0]} 00:00:00`, `${this.dateRange[1]} 23:59:59`]
      }
      if (arr[0]) {
        params.startTime = arr[0]
      }
      if (arr[1]) {
        params.endTime = arr[1]
      }
      window.parent.postMessage({
        type: "getTotal",
        data: {
            ...params
        }
      }, "*");
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = []
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.postId)
      this.single = selection.length!=1
      this.multiple = !selection.length
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加岗位";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const postId = row.postId || this.ids
      getPost(postId).then(response => {
        this.form = response.data;
        this.open = true;
        this.title = "修改岗位";
      });
    },
    /** 提交按钮 */
    submitForm: function() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.postId != undefined) {
            updatePost(this.form).then(response => {
              this.$modal.msgSuccess("修改成功");
              this.open = false;
              this.getList();
            });
          } else {
            addPost(this.form).then(response => {
              this.$modal.msgSuccess("新增成功");
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const postIds = row.postId || this.ids;
      this.$modal.confirm('是否确认删除岗位编号为"' + postIds + '"的数据项？').then(function() {
        return delPost(postIds);
      }).then(() => {
        this.getList();
        this.$modal.msgSuccess("删除成功");
      }).catch(() => {});
    },
    /** 导出按钮操作 */
    handleExport() {
      this.download('system/post/export', {
        ...this.queryParams
      }, `post_${new Date().getTime()}.xlsx`)
    },
    stateFormat(cellValue){
      if (cellValue) {
        cellValue += ''
        if (!cellValue.includes('.')) cellValue += '.'
        return cellValue
          .replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
            return $1 + ','
          })
          .replace(/\.$/, '')
      } else {
        return 0
      }
    }
  }
};
</script>
<style scoped>
.app-container{
  background: #fff;
  height: calc(100% - 0px);
  padding: 20px;
  box-sizing: border-box;
  overflow: auto;
}
.topForm{
  display: flex;
}
.totalBox{
  border: 1px dashed #EBEEF5;
  padding: 20px;
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Demo.vue